import React, { useState,useEffect,useRef, useCallback } from 'react';
import { Row, Col } from "react-bootstrap";
import { AnimatePresence,motion } from 'framer-motion';
import useEmblaCarousel from 'embla-carousel-react'

import '../lib/bootstrap.min.css'
import './Main.css';
import './SubPage.css';
import './Property.css';
import Overview from './propertyInfo/Overview';
import Facilities from './propertyInfo/Facilities';
import Accommodation from './propertyInfo/Accommodation';
import Policies from './propertyInfo/Policies';
import MeetingsEvents from './propertyInfo/MeetingsEvents';
import ArroundUs from './propertyInfo/ArroundUs';
import PhotoGallery from './propertyInfo/PhotoGallery';
import Home from './propertyInfo/Home';

const Property = (props) => {

    const ref = useRef(null);
    const refMenu = useRef(null);
    const [height,setHeight] = useState(0)
    const [width,setWidth] = useState(0)

    const [topMenu,setTopMenu] = useState(0)
    const [isPageInfo,setPageInfo] = useState('home')
    
    useEffect(() => {
        console.log(props)
        setHeight(ref.current.clientHeight);
        setWidth(ref.current.clientWidth);
        setTopMenu((ref.current.clientHeight/2)-(refMenu.current.clientHeight/2))
    }, []);

  return (
    <AnimatePresence>
        <Row>
            <Col md={12}>
                <motion.div 
                    ref={ref}
                    className='content-subpage'
                    style={{height:(props.height)+'px'}}
                    initial={{ opacity: 0, marginTop:-50 }}
                    animate={{ opacity: 1, marginTop: 0,  }}
                    exit={{opacity:0, marginTop:300}}
                    transition={{ duration: 1.2, ease: [0.87, 0, 0.13, 1] }}
                >
                    <Row>
                        <Col md={3} className='property-left' style={{height:(props.height)+'px'}}>
                            <motion.div style={{margin:'0px', width:'100%'}}
                                    initial={{ opacity: 0, marginTop:-50 }}
                                    animate={{ opacity: 1, marginTop: 0,  }}
                                    exit={{opacity:0, marginTop:300}}
                                    transition={{ duration: 1.2, ease: [0.87, 0, 0.13, 1] }}
                                >
                                <div className='plTitle'>
                                    <h2>Hotel</h2>
                                    <h3>Information</h3>
                                </div>
                                </motion.div>
                                <motion.div style={{margin:'0px', width:'100%'}}
                                    initial={{ opacity: 0, marginleftt:-50 }}
                                    animate={{ opacity: 1, marginLeft: 0,  }}
                                    exit={{opacity:0, marginLeft:300}}
                                    transition={{ duration: 1.2, ease: [0.87, 0, 0.13, 1] }}
                                >
                                <div ref={refMenu} className='plMenu'>
                                    <button onClick={()=>{setPageInfo('home')}} className={isPageInfo === "home" && "active"} >Home</button>
                                    <button onClick={()=>{setPageInfo('overview')}} className={isPageInfo === "overview" && "active"} >Overview</button>
                                    <button onClick={()=>{setPageInfo('facilities')}} className={isPageInfo === "facilities" && "active"} >Hotel Facilities</button>
                                    <button onClick={()=>{setPageInfo('accommodation')}} className={isPageInfo === "accommodation" && "active"}>Accommodation</button>
                                    <button onClick={()=>{setPageInfo('photogallery')}} className={isPageInfo === "photogallery" && "active"}>Photo Gallery</button>
                                </div>
                            </motion.div>
                        </Col>
                        <Col md={9} style={{padding:0}}>
                            <Row  style={{padding:0}}>
                                <Col md={12} style={{padding:0}}>
                                    { isPageInfo === "home" && 
                                            <Home 
                                                content={props.home}
                                                height={height} width={width} /> }
                                                
                                    { isPageInfo === "overview" && 
                                            <Overview 
                                                content= {props.content.overview}
                                                height={height} width={width} /> }

                                    { isPageInfo === "facilities" && 
                                            <Facilities 
                                                content= {props.content.hotel_facilities}
                                                height={height} width={width} /> }

                                    { isPageInfo === "accommodation" && 
                                            <Accommodation 
                                                content={props.content.accommodation} 
                                                height={height} width={width} /> }


                                    { isPageInfo === "photogallery" && 
                                            <PhotoGallery 
                                            content= {props.content.photogallery}
                                            height={height} width={width} /> }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </motion.div>
            </Col>
        </Row>
    </AnimatePresence>
  )};

export default Property;


